// Navigation & search index. Routes: /topic/:slug for TOPICS, plus special pages.
export const NAV_GROUPS = [
  {
    label: "Learning Hub",
    description: "Who Are the Yorùbá? Start your journey here.",
    items: [
      { title: "Origins & History", to: "/topic/origins-and-history" },
      { title: "The Yorùbá Language", to: "/topic/language" },
      { title: "Yorùbá Dictionary (A–Z)", to: "/dictionary" },
      { title: "Yorùbá Names (A–Z)", to: "/names" },
      { title: "Religion & Spirituality", to: "/topic/religion-and-spirituality" },
      { title: "Social Structure & Values", to: "/topic/social-structure" },
      { title: "Arts, Culture & Creativity", to: "/topic/arts-culture-creativity" },
      { title: "Global Influence & Diaspora", to: "/topic/global-influence-diaspora" },
      { title: "Yorùbá Identity Today", to: "/topic/yoruba-identity-today" },
      { title: "Why the Yorùbá Matter", to: "/topic/why-yoruba-matter" },
    ],
  },
  {
    label: "Deep Knowledge",
    description: "Detailed explorations of Yorùbá heritage.",
    items: [
      { title: "Yorùbá History Timeline", to: "/timeline" },
      { title: "Yorùbá Mythology", to: "/topic/mythology" },
      { title: "Yorùbá Proverbs (Òwe)", to: "/proverbs" },
      { title: "Òrìṣà Encyclopedia", to: "/orisa" },
      { title: "Yorùbá Royal Titles", to: "/royal-titles" },
      { title: "Museums & Institutions", to: "/museums" },
      { title: "Yorùbá Culture Quiz", to: "/quiz" },
      { title: "Question of the Day", to: "/daily-question" },
      { title: "Worldview & Philosophy", to: "/topic/worldview-philosophy" },
      { title: "Yorùbá Festivals", to: "/topic/festivals" },
      { title: "Traditional Clothing", to: "/topic/traditional-clothing" },
      { title: "The Naming System", to: "/topic/naming-system" },
      { title: "Kingship & Politics", to: "/topic/kingship" },
    ],
  },
  {
    label: "Philosophy",
    description: "The soul, ethics, and wisdom of the Yorùbá.",
    items: [
      { title: "Omolúàbí Philosophy", to: "/topic/omoluabi" },
      { title: "Orí Explained", to: "/topic/ori" },
      { title: "Ifá Philosophy Simplified", to: "/topic/ifa-philosophy" },
      { title: "Concept of the Soul", to: "/topic/concept-of-soul" },
      { title: "Ethics & Moral System", to: "/topic/ethics-moral-system" },
      { title: "Life Stages", to: "/topic/life-stages" },
      { title: "Death & Ancestors", to: "/topic/death-and-ancestors" },
    ],
  },
  {
    label: "Get Involved",
    description: "Join the movement and support Yorùbá heritage.",
    items: [
      { title: "Our Project", to: "/project" },
      { title: "Membership", to: "/membership" },
      { title: "Be a Volunteer", to: "/volunteer" },
      { title: "Support Us / Donate", to: "/support" },
    ],
  },
  {
    label: "About",
    description: "Who we are and who leads us.",
    items: [
      { title: "About Us", to: "/about" },
      { title: "Visionary Leadership", to: "/leadership" },
    ],
  },
];

export const MAIN_LINKS = [
  { title: "Courses", to: "/courses" },
  { title: "Adverts", to: "/adverts" },
  { title: "Shop", to: "/shop" },
  { title: "Gallery", to: "/gallery" },
  { title: "Events", to: "/events" },
  { title: "Celebrate", to: "/celebrate" },
  { title: "News", to: "/news" },
  { title: "Journal", to: "/blog" },
];

// Flat index for search (deduped by route)
const _rawIndex = [
  { title: "Home", to: "/", keywords: "yoruba culture home" },
  { title: "About ÀsÀNigHT Worldwide", to: "/about", keywords: "mission vision preservation" },
  { title: "Visionary Leadership", to: "/leadership", keywords: "leaders directors organizing secretaries team" },
  { title: "Our Project", to: "/project", keywords: "satellites centres london rhode island ontario community complex" },
  { title: "Membership", to: "/membership", keywords: "join member support donate patron family" },
  { title: "Be a Volunteer", to: "/volunteer", keywords: "volunteer work with us teaching arts fashion dancing concert" },
  { title: "Support Us / Donate", to: "/support", keywords: "donate donation support sponsor bequest grant non-profit" },
  { title: "Yorùbá History Timeline", to: "/timeline", keywords: "history ife oyo empire diaspora" },
  { title: "Òrìṣà Encyclopedia", to: "/orisa", keywords: "orisa sango osun ogun yemoja deities gods" },
  { title: "Yorùbá Dictionary A–Z", to: "/dictionary", keywords: "dictionary names words meaning translate glossary vocabulary phrases" },
  { title: "Yorùbá Proverbs (Òwe)", to: "/proverbs", keywords: "proverbs owe wisdom sayings elders philosophy ethics quotes" },
  { title: "Yorùbá Royal Titles", to: "/royal-titles", keywords: "royal titles oba king kingdom ooni alaafin alake awujale throne monarch crown chieftaincy oye" },
  { title: "Museums & Cultural Institutions", to: "/museums", keywords: "museums cultural institutions heritage sites galleries archives national museum lagos ife antiquities osun osogbo sacred grove nike art terra kulture esie soapstone monuments unesco" },
  { title: "Yorùbá Names A–Z", to: "/names", keywords: "names oruko baby naming meaning gender directory yoruba christening" },
  { title: "Yorùbá Culture Quiz (Ìdánwò)", to: "/quiz", keywords: "quiz idanwo test knowledge trivia questions game orisa history language play" },
  { title: "Question of the Day (Ìbéèrè t'òní)", to: "/daily-question", keywords: "question of the day daily reflection ibeere ojo riddle alo proverb meaning ponder wisdom" },
  { title: "Journal & Articles", to: "/blog", keywords: "blog news articles updates" },
  { title: "Gallery", to: "/gallery", keywords: "gallery photos images art portraits festivals textiles videos" },
  { title: "Birthday Shoutouts", to: "/celebrate", keywords: "birthday shoutout celebrate happy birthday wishes members celebration ojo ibi" },
  { title: "Events Calendar", to: "/events", keywords: "events calendar concerts exhibitions festivals gatherings upcoming shows whats on" },
  { title: "Shop", to: "/shop", keywords: "shop store buy products textiles crafts art merchandise market cart" },
  { title: "Courses (Learning Portal)", to: "/courses", keywords: "courses learning portal yoruba language lessons beginner intermediate premium enroll classes tuition alphabet numbers greetings verbs" },
  { title: "Adverts", to: "/adverts", keywords: "adverts advertisements ads promotions announcements banners sponsors partners" },
  { title: "News & Statements", to: "/news", keywords: "news statements announcements press updates" },
  ...NAV_GROUPS.flatMap((g) => g.items.map((i) => ({ ...i, keywords: g.label }))),
  { title: "Modern Relevance", to: "/topic/modern-relevance", keywords: "afrobeats fashion diaspora spirituality" },
];

const _seen = new Set();
export const SEARCH_INDEX = _rawIndex.filter((i) => {
  if (_seen.has(i.to)) return false;
  _seen.add(i.to);
  return true;
});
